export enum ViewOptions {
	default = "default",
	polling = "polling",
	qr = "qr-code",
	personalNumber = "personal-number",
}

export enum QrComponentViewOptions {
	default = "default",
	polling = "polling",
	qr = "qr-code",
}

export const LOGIN_BANKID_TRANSLATION_KEYS = {
	images: ["general.bankid", "general.bankid.error"],
	translations: [
		"general.ok",
		"general.close",
		"general.cancel",
		"general.contact",
		"sga-auth-transaction.bankid.start",
		"sga-auth-transaction.login-short-description",
		"sga-auth-transaction.retry-bankid",
		"sga-auth-transaction.bankid-on-another-device",
		"sga-auth-transaction.retry-bankid-on-another-device",
		"sga-auth-transaction.polling",
		"sga-auth-transaction.polling-timeout",
		"sga-auth-transaction.bankid-login-title",
		"sga-auth-transaction.bankid-registration-title",
		"sga-auth-transaction.bankid-welcome-title",
		"sga-auth-transaction.bankid-welcome-subtitle",
		"sga-auth-transaction.bankid-polling-subtitle",
		"sga-auth-transaction.bankid-qr-code-subtitle",
		"sga-auth-transaction.bankid-personal-number-title",
		"sga-auth-transaction.bankid-personal-number-subtitle",
		"sga-auth-transaction.personal-number-continue",
		"sga-auth-transaction.registration.not-swedish-resident-message",
		"sga-auth-transaction.registration.not-swedish-resident-action",
		"sga-auth-transaction.registration.bankid-error-message",
		"sga-auth-transaction.registration.bankid-error-action",
		"sga-auth-transaction.registration.personal-number-try-again-message",
		"sga-auth-transaction.registration.personal-number-try-again-action",
		"sga-auth-transaction.login.no-account-message",
		"sga-auth-transaction.login.no-account-action",
		"sga-auth-transaction.login.bankid-error-message",
		"sga-auth-transaction.login.bankid-error-action",
		"sga-auth-transaction.polling-cancel-message",
		"sga-auth-transaction.polling-cancel-action",
		"sga-auth-transaction.qr-code-different-method-message",
		"sga-auth-transaction.qr-code-different-method-action",
		"sga-login-transaction.m_cancel_last_verification_success",
		"sga-login-transaction.error.text",
		"sga-login-transaction.e_personalverification_nodata",
		"sga-login-transaction.e_validation",
		"sga-login-transaction.e_validation_personalnumberinvalidchecksum",
		"sga-login-transaction.e_validation_personalnumber",
		"sga-login-transaction.e_validation_personalnumberinvaliddate",
		"sga-login-transaction.e_validation_personalnumberunderage",
		"sga-login-transaction.e_validation_personalnumberinvalidlength",
		"sga-login-transaction.e_personalnumber_addressnotinsweden",
		"sga-login-transaction.e_personalnumber_invalidpersonalnumber",
		"sga-login-transaction.e_personalnumber_sparlookup_personalnumbernotfound",
		"sga-login-transaction.e_personalnumber_sparlookup",
		"sga-login-transaction.e_personalnumber_sparlookup_invalidrequest",
		"sga-login-transaction.e_personalnumber_sparlookup_maxattemptsreached",
		"sga-login-transaction.e_personalnumber_sparlookup_unavailable",
		"sga-login-transaction.initialize.fail",
		"sga-login-transaction.error.personal-number-not-found",
		"sga-login-transaction.e_session_login_dailysessionlimitexpired",
		"sga-login-transaction.e_session_login_weeklysessionlimitexpired",
		"sga-login-transaction.e_session_login_monthlysessionlimitexpired",
		"sga-login-transaction.e_sessions_login_accountnotverified",
		"sga-login-transaction.m_sessions_login_accountvalidated",
		"sga-login-transaction.e_sessions_login_customernotallowed",
		"sga-login-transaction.e_sessions_login_customerselfexcluded",
		"sga-login-transaction.e_sessions_login_customerselfexcludedfromgamstop",
		"sga-login-transaction.e_sessions_login_customerselfexcludedfromsga",
		"sga-login-transaction.e_sessions_login",
		"sga-login-transaction.e_sessions_login_maxattemptsreached",
		"sga-login-transaction.e_session_login_sessionlimitexpired",
		"sga-login-transaction.e_sessions_login_typenotallowed",
		"sga-login-transaction.e_sessions_login_2fa_maximum_attempts_reached",
		"sga-login-transaction.e_credentials_password_reset_required",
		"sga-login-transaction.bankid-not-responding-error",
	],
	qrCodeComponentTranslations: [
		"sga.qr-generate",
		"sga.qr-instructions",
		"sga.qr-start-bankid",
		"sga.qr-click",
		"sga.qr-scan",
	],
};
